export const COLOR_MODE = "COLOR_MODE";
export const LANGUAGE = "LANGUAGE";
export const CART = "CART";
export const PAYMENT_TYPE = "PAYMENT_TYPE";
export const NOTE = "NOTE";
export const CHANGE_PASSWORD_REDIRECT = "CHANGE_PASSWORD_REDIRECT";
export const BANNER_SEEN_DATE = "BANNER_SEEN_DATE";
export const PRODUCTS_SCROLL_DATA = "PRODUCTS_SCROLL_DATA";

export const NECESSARY_COOKIES = "NECESSARY_COOKIES";
export const OPTIONAL_COOKIES = "OPTIONAL_COOKIES";
